// client/src/pages/Home.js

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import EventsSection from '../components/EventsSection';
import InfoCards from '../components/InfoCards';
import AboutSection from '../components/sections/AboutSection';
import CoopModelSection from '../components/sections/CoopModelSection';
import WhyJoinSection from '../components/sections/WhyJoinSection';
import JoinWaitlistSection from '../components/sections/JoinWaitlistSection';
import HeroSection from '../components/sections/HeroSection';
import MissionStatement from '../components/sections/MissionStatement';
import TheCompetitionSection from '../components/sections/TheCompetitionSection';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <>
      <HeroSection />

      {/* Section Break */}
      <div className="section-break" />

      <MissionStatement />

      {/* Section Break */}
      <div className="section-break" />

      <AboutSection />

      {/* Section Break */}
      <div className="section-break" />

      <EventsSection />

      {/* Section Break */}
      <div className="section-break" />

      <CoopModelSection />

      {/* Section Break */}
      <div className="section-break" />

      <TheCompetitionSection />

      {/* Section Break */}
      <div className="section-break" />

      <WhyJoinSection />

      {/* Section Break */}
      <div className="section-break" />

      <JoinWaitlistSection />

      <InfoCards />
      {/* Section Break */}
      {/* <div className="section-break" />
      <ColorShowcase /> */}
      {/* Section Break */}
      {/* <div className="section-break" />
      <ColorPalettePreview /> */}
    </>
  );
};

export default Home;
